import React, {Component} from 'react';
import toastr from "toastr";
import _ from 'lodash';
import { getJwt } from '../../../services/authService';

import http from "../../../services/httpService";

import {paginate} from '../../utils/paginate_posts'

import {Menu, MenuItem, Tag, Spinner} from "@blueprintjs/core";
import {
    Cell,
    Column,
    CopyCellsMenuItem,
    IMenuContext,
    SelectionModes,
    RenderMode,
    Table,
    Utils,
    TableLoadingOption
} from "@blueprintjs/table";
import ItemsPerPage from '../../common/ItemsPerPage';
import Pagination from '../../common/Pagination';
import TableNoData from '../../common/TableNoData';

const optionsPageSize = [
    {value: 10, text: 10},
    {value: 25, text: 25},
    {value: 50, text: 50},
];

const multiPostGlobalPartHeight = 70;
const multiPostSinglePostHeight = 50;

let spinnerComponent = <div style={{marginBottom: 7}}><Spinner size={15}/></div>
let horizontalClickedSpinner = <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
    <i className="fas fa-envelope-open" style={{color: '#18A9E3'}}></i>
    <div style={{marginLeft: 5}}><Spinner size={15}/></div>
    <div style={{marginLeft: 5}}><Spinner size={15}/></div>
</div>;

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class WhatsAppCampaignPerformance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            campaigns: [],
            posts: '',
            totalPosts: '',
            totalPages: '',
            totalCampaigns: 0,
            total_subscribers: 0,
            push_subscribers: [],
            pageSize: 10,
            currentPage: 1,
            lastPage: false,
            lastPageSize: '',
            paging: '',
            selectedAdAccount: '',
            sortColumn: {
                path: "updated_at",
                order: "asc"
            },
            loader: true,
            selectedCampaignPerformance: 'MESSAGES',
            preview: '',
            forceTableRerender: false,
            selectedSubType: '',
            selectedSubTypeFinished: '',
            selectedType: '',
            selectedTypeFinished: '',
            rowHeights: [100,100,100,100,100],
            lastColumnWidth: ''
        }

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
    }

    getPostsData = async () =>{
        try{
            await this.setState({loader: true})
            const pageSize = await this.state.pageSize;
            let selectedSubType = await this.props.selectedSubType;
            let selectedType = await this.props.selectedType;
            let selectedSource = this.props.selectedSource;
            // let selectedSource = '1160';
            // let selectedSource = '1299';

            let apiCallType = await selectedSubType.name === 'Show All' ? 'all_webpush_posts' :
                selectedSubType.name === 'Autopush' ? 'webpush_auto_posts' : 'webpush_custom_posts';

            const result = await http.get('api/' + apiCallType +'/page_size/' + this.state.pageSize +'/feed/' + selectedSource + '?page='+ this.state.currentPage, {headers: {authorization: getJwt()}});
            const data = await result.data;
            // console.log('Ojha aloha: ', data)
            //this.props.selectedSubType.name === 'Multiple Custom Links' ? [200,200,200,200,300,300,300,200,200,200] : [100,100,100,100,100,100,100,100,100,100],
            let rowHeights = await data.posts.map( () => 100);
            await this.setState({
                rowHeights,
                posts: data.posts ? data.posts.length > 0 ? data.posts : '' : '',
                selectedSubType: selectedSubType.name,
                selectedType: selectedType.name,
                totalPosts: data.total_posts,
                totalPages: data.total_pages,
                lastPage: (data.total_pages < 1) || (this.state.currentPage === data.total_pages) ? true : false,
                lastPageSize: ((data.total_posts % this.state.pageSize) === 0) ? data.total_posts === 0 ? 0 : this.state.pageSize :
                    ((data.total_posts % this.state.pageSize) < 0) ? data.total_posts : data.total_posts % this.state.pageSize,
                selectedSubTypeFinished: this.props.selectedSubType.name,
                selectedTypeFinished: this.props.selectedType.name,
                loader: data.posts.length < 1 ? false : true
            })
            if (!this.state.posts){
                this.setState({loader: false})
            }
            await this.setState({ forceTableRerender: true })
            await this.setState({ forceTableRerender: false })
        } catch(ex) {
            if (ex.response && ex.response.status === 404)
                this.setState({loader: false})
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
    }

    async componentDidMount() {
        
        try {
            await this.getPostsData()
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
        if (!this.state.posts && !this.state.loader){
            await this.recalculateColsWidth(790)
        } else if (this.state.selectedSubTypeFinished === this.props.selectedSubType.name)  {
            await this.recalculateColsWidth(960)
        } else {
            await this.recalculateColsWidth(800)
        }

        //this.getPreview();
    }



    componentDidUpdate=()=> {
        if (this.state.selected_source !== this.props.selected_source) {

            this.handlePageChange(1, this.props.selected_source, "all");
        }
        if ( this.state.selectedAdAccount !== this.props.user.add_account_id){
            this.setState({
                currentPage: 1,
                selectedAdAccount: this.props.user.add_account_id
            })
        }
        if( (this.state.selectedSubType !== this.props.selectedSubType.name) && this.state.selectedSubType && this.props.selectedSubType ){
            this.setState({
                loader: true,
                currentPage: 1,
                selectedSubType: this.props.selectedSubType.name,
            })
            this.getPostsData();
        }
        if( (this.state.selectedType !== this.props.selectedType.name) && this.state.selectedType && this.props.selectedType ){
            this.setState({
                loader: true,
                currentPage: 1,
                selectedType: this.props.selectedType.name
            })
            this.getPostsData();
        }
    }


    handlePageChange = async (number)  => {
        let page = parseInt(number)
        if ((page !== 0) && (page !== this.state.lastPage)){
            await this.setState({currentPage: page, loader: true});
            this.getPostsData()
        }
    };

    // selectCampaignPerformanceOption = async (selected) =>{
    //     await this.setState({
    //         selectedCampaignPerformance: selected,
    //     })
    //     this.getPostsData()
    // }

    handleChangeCampaignsNumberPerPage = async (value) =>{
        await this.setState({
            currentPage: 1,
            pageSize: value,
            lastPage: value > this.state.totalPosts ? true : this.state.lastPage,
            lastPageSize: value > this.state.totalPosts ? this.state.totalPosts : this.state.lastPageSize,
            loader: true
        })
        await this.getPostsData()
    }

    getPreview = async () =>{
        if ( !this.state.preview ){
            try{
                const add_account_token = 'EAAZAfK9tK44IBADVZBY4gjXJZBqKdAdCqQokgs5uVNiWm9PtZA7L1qvMF6w2qmNcZCPZAfTfZCCtoxhfW0N3KJZBeRkXLMCfpKuq3SNu3Ybvl9R7JSJU337WcOZB4ZCeO2RyZCLBsBN7j5iDk8GyF2FhUAlbI6C6obOPLB2rCekBNYeGQZDZD';
                const add_account_id = 'act_269773933645768';
                const campaign = await this.state.campaigns[0] || {};
                const link = 'https://nba.com';
                let object_story_spec = {
                    "page_id": 106911734110630,
                    "link_data": {
                        "call_to_action": {
                            "type": "USE_APP",
                            "value": {
                                "link": link
                            }
                        },
                        "description": "Ovde ide opis",
                        "link": link,
                        "message": "Probna Poruka",
                        "name": "Ovde ide ime",
                        "picture": link
                    }
                }
                // const adsetId = await campaign.adsets.data[0].id || '';
                // const result = await http.get('https://graph.facebook.com/v4.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative={"type":27, "object_id": 112886416838535}&post={"link":"https://nba.com", "message":"Lorem ipsum dolor sit amet","picture":"http://url.to/your/custom/image.jpg","name":"Facebook","caption":"www.facebook.com","description":"Lorem ipsum dolor sit amet"}')
                const result = await http.get(facebook_app_marketing_url + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                    '&ad_format=MOBILE_FEED_STANDARD&creative={"object_story_spec": {"page_id": "106911734110630", "link_data": { "call_to_action": {"type": "LEARN_MORE", "value": { "link": "https://nba.com" } },"description": "Ovde ide opis", "link": "https://nba.com", "message": "Probna Poruka","name": "Ovde ide ime", "picture": "https://cdn.pixabay.com/photo/2015/12/01/20/28/road-1072823__340.jpg" }}}', {headers: {authorization: getJwt()}})

                // Ad formats: DESKTOP_FEED_STANDARD, FACEBOOK_STORY_MOBILE, INSTAGRAM_EXPLORE_CONTEXTUAL, INSTAGRAM_EXPLORE_IMMERSIVE, INSTAGRAM_STANDARD, INSTAGRAM_STORY, INSTANT_ARTICLE_RECIRCULATION_AD, INSTANT_ARTICLE_STANDARD, INSTREAM_VIDEO_DESKTOP, INSTREAM_VIDEO_MOBILE, MESSENGER_MOBILE_INBOX_MEDIA, MESSENGER_MOBILE_STORY_MEDIA, MOBILE_BANNER, MOBILE_FEED_BASIC, MOBILE_FEED_STANDARD, MOBILE_FULLWIDTH, MOBILE_INTERSTITIAL, MOBILE_MEDIUM_RECTANGLE, MOBILE_NATIVE, RIGHT_COLUMN_STANDARD, SUGGESTED_VIDEO_DESKTOP, SUGGESTED_VIDEO_MOBILE, WATCH_FEED_MOBILE"
                // const result = await http.get('https://graph.facebook.com/v5.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative=[{"object_story_spec": "' + object_story_spec + '"}]')


                const iframe = await result.data.data[0].body;
                await this.setState({preview: iframe})
            } catch(e) {
                //console.log('error: ', e)
            }
        }

    }

    typeCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.posts[rowIndex];
        // Temporarly placed for removing loader state
        if ((rowIndex === (this.state.lastPage ? this.state.lastPageSize : this.state.pageSize) - 1) && this.state.loader) {
            setTimeout(() => this.setState({loader: false}), 2500)
        }
        return <Cell
            className='campaign-name'
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        ><div className="type-container">
            {/*<i className="fas fa-eye eye-icon" onClick={()=>console.log('Kliknuo sam')}></i>*/}
            <div >
                { this.state.loader ?
                    <div style={{marginTop: 8}}>
                        { spinnerComponent }
                    </div>
                    :
                    <i className={ item.type === 'custom_single' ? 'fas fa-eye type-icon' : 'fas fa-sync-alt type-icon' }></i>
                }
            </div>
        </div>
        </Cell>
    };

    typeCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell
            className='campaign-name'
            style={ { backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7' } }
        >
            <div className="type-container">
                {/*<i className="fas fa-eye eye-icon"></i>*/}
                <div >
                    <div style={{marginTop: 8}}>
                        { spinnerComponent }
                    </div>
                </div>
            </div>
        </Cell>
    };

    sentCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.posts[rowIndex];
        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7', height: '100%', justifyContent: 'flex-start', paddingTop: 13}}
        ><div className='sent-cell-container'>
            <i className="fas fa-paper-plane type-icon" style={{ marginBottom: 5}}></i>
            { this.state.loader ? spinnerComponent : <p style={{fontWeight: 'bold'}}>{item.data.sent_wp_post_total}</p>}
        </div>
        </Cell>
    };

    sentCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7', height: '100%', justifyContent: 'flex-start', paddingTop: 13}}
        ><div className='sent-cell-container'>
            <i className="fas fa-paper-plane type-icon" style={{ marginBottom: 5}}></i>
            { spinnerComponent }
        </div>
        </Cell>
    };

    clickedCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.posts[rowIndex];
        return <Cell
            className='campaign-name'
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        ><div className='sent-cell-container'>
            <i className="fas fa-envelope-open" style={{color: '#18A9E3', marginBottom: 5}}></i>
            { this.state.loader ? spinnerComponent : <p>{item.data.opened_wp_post_total}</p> }
            { this.state.loader ? spinnerComponent : <p style={{color: '$grey-border' }}>{item.data.percent_wp_post_total}</p> }
        </div>
        </Cell>
    };

    clickedCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell
            className='campaign-name'
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        ><div className='sent-cell-container'>
            <i className="fas fa-envelope-open" style={{color: '#18A9E3', marginBottom: 5}}></i>
            { spinnerComponent }
            { spinnerComponent }
        </div>
        </Cell>
    };


    imageCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.posts[rowIndex];

        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >{ this.state.loader ?
            <div className='image-cell'><div className='image-skeleton bp3-skeleton'/></div>
            :
            item.image ?
                <div className='image-cell'> <img src={item.image} /></div>
                :
                null
        }</Cell>
    };

    imageCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell
            className='campaign-name'
            style={ { backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7' } }
        >
            <div className='image-cell'><div className='image-skeleton bp3-skeleton'/></div>
        </Cell>
    }

    titleCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.posts[rowIndex];
        return <Cell style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}>
            {
                this.state.loader ?
                    <div>
                        <div className='bp3-skeleton text-skeleton'/>
                        <div className='bp3-skeleton text-skeleton'/>
                        <div className='bp3-skeleton text-skeleton'/>
                        <div className='bp3-skeleton text-skeleton'/>
                    </div>
                    :
                    <p className='multi-line-text-cell'>{item.title}</p>
            }
        </Cell>
    };

    titleCellRendererLoading = (rowIndex, columnIndex) => {

        return <Cell
            className='campaign-name'
            style={ { backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7' } }
        >
            <div>
                <div className='bp3-skeleton text-skeleton'/>
                <div className='bp3-skeleton text-skeleton'/>
                <div className='bp3-skeleton text-skeleton'/>
                <div className='bp3-skeleton text-skeleton'/>
            </div>
        </Cell>
    }

    messageCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.posts[rowIndex];
        if (item && (this.state.selectedSubTypeFinished === 'Single Custom Links')){
            return <Cell style={ { backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7' } }>
                {
                    this.state.loader ?
                        <div>
                            <div className='bp3-skeleton text-skeleton'/>
                            <div className='bp3-skeleton text-skeleton'/>
                            <div className='bp3-skeleton text-skeleton'/>
                            <div className='bp3-skeleton text-skeleton'/>
                        </div>
                        :
                        <p className="multi-line-text-cell">{ item.content }</p>
                }
            </Cell>
        } else if (item && (this.state.selectedSubTypeFinished === 'Multiple Custom Links')) {
            return <Cell style={ { backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7',justifyContent: 'flex-start', paddingBottom: 5 } }>
                <div style={{height: multiPostGlobalPartHeight}}/>
                <div className={"multi-line-text-big-container"} >
                    {item.posts.map( (post, index) => <div key={index} className={"multi-line-text-big-container"} style={{height: multiPostSinglePostHeight}}>
                        {
                            this.state.loader ?
                                <div>
                                    <div className='bp3-skeleton text-skeleton'/>
                                    <div className='bp3-skeleton text-skeleton'/>
                                </div>
                                :
                                <p className="multi-line-text-cell-big" style={{height: multiPostSinglePostHeight-10, marginBottom: 10 }}>{post.content}</p>
                        }
                    </div>)}
                </div>
            </Cell>
        } else if (item && (this.state.selectedSubTypeFinished === 'Text Message')) {
            return <Cell style={ { backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7' } }>
                {
                    this.state.loader ?
                        <div>
                            <div className='bp3-skeleton text-skeleton'/>
                            <div className='bp3-skeleton text-skeleton'/>
                            <div className='bp3-skeleton text-skeleton'/>
                            <div className='bp3-skeleton text-skeleton'/>
                        </div>
                        :
                        <p className="multi-line-text-cell">{ item.message }</p>
                }
            </Cell>
        } else {
            return <div/>
        }
    }

    messageCellRendererLoading = (rowIndex, columnIndex) => {
        /* Ovde se dobija greška na Text Message strani */
        if ((this.props.selectedSubType.name === 'Single Custom Links')||(this.props.selectedSubType.name === 'Text Message')){
            return <Cell
                className='campaign-name'
                style={ { backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7' } }
            >
                <div>
                    <div className='bp3-skeleton text-skeleton'/>
                    <div className='bp3-skeleton text-skeleton'/>
                    <div className='bp3-skeleton text-skeleton'/>
                    <div className='bp3-skeleton text-skeleton'/>
                </div>
            </Cell>
        } else if (this.props.selectedSubType.name === 'Multiple Custom Links'){
            return <Cell
                className='campaign-name'
                style={ { backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7' } }
            >
                <div style={{height: multiPostGlobalPartHeight}}>

                </div>
                <div className={"multi-line-text-big-container"} style={{height: multiPostSinglePostHeight}}>
                    <div className='bp3-skeleton text-skeleton'/>
                    <div className='bp3-skeleton text-skeleton'/>
                </div>
                <div className={"multi-line-text-big-container"} style={{height: multiPostSinglePostHeight}}>
                    <div className='bp3-skeleton text-skeleton'/>
                    <div className='bp3-skeleton text-skeleton'/>
                </div>
                <div className={"multi-line-text-big-container"} style={{height: multiPostSinglePostHeight}}>
                    <div className='bp3-skeleton text-skeleton'/>
                    <div className='bp3-skeleton text-skeleton'/>
                </div>
            </Cell>
        } else {
            return <div/>
        }
    }

    linkCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.posts[rowIndex];

        return <Cell style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}>
            <div >
                <a href={item.short_url} target="_blank"><i className="fas fa-link type-icon"></i></a>
            </div>
        </Cell>
    };
    linkCellRendererLoading = (rowIndex, columnIndex) => {

        return <Cell style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}>
            <div >
                <i className="fas fa-link type-icon"></i>
            </div>
        </Cell>
    };
    /* Tags for Multiple custom links should be returned for the post selected and not inside sub post*/
    tagsCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.posts[rowIndex];

        return <Cell style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7', display: 'flex', justifyContent: 'flex-start', paddingTop: 10}} wrapText={true}>{
            this.state.loader ?
                <div className="bp3-skeleton" style={{width: 100, height: 20}}/>
                :
                item.data.tags && item.data.tags.length >0 ? item.data.tags.map( tag => <Tag
                    className={['custom-tag', tag.toLowerCase() === 'immediate' ? 'bp3-intent-primary' : tag.toLowerCase() === 'daily' ?
                        'bp3-intent-success' : tag.toLowerCase() === 'weekly' ? 'bp3-intent-warning' :
                            tag.toLowerCase() === 'weekly' ? 'bp3-intent-darkblue' : '']}
                    key={tag}
                >
                    {tag.toLowerCase()}
                </Tag>) : <Tag className='bp3-intent-darkblue' >everyone</Tag>}</Cell>
    };

    tagsCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7', display: 'flex', justifyContent: 'flex-start', paddingTop: 10}}>
            <div className="bp3-skeleton" style={{width: 100, height: 20}}/>
        </Cell>
    };

    sentAtCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.posts[rowIndex];
        let date = item.sent_at_timezone ? item.sent_at_timezone.substr(0,item.sent_at_timezone.indexOf(' ')) : 'No date';
        let time = item.sent_at_timezone ? item.sent_at_timezone.substr(item.sent_at_timezone.indexOf(' ')+1) : 'No time';


        return <Cell style={{
            backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7', justifyContent: 'flex-start', paddingTop: 10
        }}>{ this.state.loader ?
            <div>
                <div className="bp3-skeleton" style={{width: 100, height: 20, marginBottom: 5}}/>
                <div className="bp3-skeleton" style={{width: 100, height: 20}}/>
            </div>
            : <div>
            <p style={{marginBottom: 5}}>{date}</p>
            <p style={{color: 'rgb(164, 175, 183)'}}>{time}</p>
        </div> || 'No date'}</Cell>
    };

    sentAtCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7', display: 'flex', justifyContent: 'flex-start', paddingTop: 10}}>
            <div>
                <div className="bp3-skeleton" style={{width: 100, height: 20, marginBottom: 5}}/>
                <div className="bp3-skeleton" style={{width: 100, height: 20}}/>
            </div>
        </Cell>
    };

    sortColumn = (columnIndex, comparator) => {
        const { data } = this.state;
        const sortedIndexMap = Utils.times(data.length, (i) => i);
        sortedIndexMap.sort((a, b) => {
            return comparator(data[a][columnIndex], data[b][columnIndex]);
        });
        this.setState({ sortedIndexMap });
    };

    headerSortMenu = () =>{
        const sortAsc = () => this.sortColumn(this.index, (a, b) => this.compare(a, b));
        const sortDesc = () => this.sortColumn(this.index, (a, b) => this.compare(b, a));
        return (
            <Menu>
                <MenuItem icon="sort-asc" onClick={sortAsc} text="Sort Rank Asc" />
                <MenuItem icon="sort-desc" onClick={sortDesc} text="Sort Rank Desc" />
            </Menu>
        );
    }


    updateTableWidth = (index, width) =>{
        /* For table width to be rerendered forceRerenderOnSelectionChange in table props should be updated with
         forceTableRerender state change */
        let newTable = this.state.tableColumnsWidth;
        newTable[index] = width;
        this.setState({
            tableColumnsWidth: newTable,
            forceTableRerender: true
        })
        this.setState({
            forceTableRerender: false
        })
    }

    renderBodyContextMenu = (context) => {
        // console.log('Ovo je context: ', context)
        return (
            <Menu>
                <CopyCellsMenuItem context={context} getCellData={this.getCellData} text="Copy"/>
            </Menu>
        );
    };

    recalculateColsWidth = async (tableTotalWidth) => {
        let lastWidth = 150;
        let remainingSpace = 0;
        if (window.innerWidth > 1500) {
            lastWidth = window.innerWidth - tableTotalWidth - 280;
            // remainingSpace = 620 + 280;
            // console.log('Jedan: ', window.innerWidth, lastWidth, remainingSpace )
        } else if ((window.innerWidth < 1500)&&(window.innerWidth > 1030) ) {
            lastWidth = window.innerWidth - tableTotalWidth - 230;
            // remainingSpace = 620 + 230;
            // console.log('Dva: ', window.innerWidth, lastWidth, remainingSpace )
        } else {
            lastWidth = window.innerWidth - tableTotalWidth;
            // remainingSpace = 0;
            // console.log('Tri: ', window.innerWidth, lastWidth, remainingSpace )
        }

        // let columnsWidth = await array;

        // ( this.state.selectedSubTypeFinished === 'Single Custom Links' ) && (this.props.selectedSubType.name === 'Single Custom Links' ) ?
        //     columnsWidth = await [100, 100, 100, 120, 150, 200, 80, 200, lastWidth]
        //     :
        //     columnsWidth = await [100, 100, 100, 120, 150, 200, 80, 200,150]
        // await this.setState({
        //     tableColumnsWidth: columnsWidth,
        //     minTableWidth: window.innerWidth - remainingSpace
        // })
        if ( (this.state.lastColumnWidth !== lastWidth) && (lastWidth > 0)){
            await this.setState({ lastColumnWidth: lastWidth})
            await this.setState({ forceTableRerender: true })
            await this.setState({ forceTableRerender: false })
        }
        // console.log(lastWidth)
    }

    render() {
        const {pageSize, currentPage, sortColumn, searchQuery, sub_type, type_of_subscription, total_subscribers} = this.state;
        let {
            subscribers: subscribersAll,
            //push_subscribers: subscribersPush
        } = this.state;



        let filtered = subscribersAll;
        if (searchQuery) {
            if (sub_type) {
                filtered = subscribersAll.filter(m => m.subscriber_name.toLowerCase().includes(searchQuery.toLowerCase()));
            }
        }

        return (
            <React.Fragment>
                <div className="d-block">
                    {/*{ this.state.preview ? <div dangerouslySetInnerHTML={{ __html: this.state.preview }} /> : null }*/}
                    <div>
                    </div>
                    {/*{ console.log( (!this.state.posts || this.state.posts.length < 1), !this.state.loader)}*/}
                    {/*Proveriti ovaj uslov*/}
                    { (!this.state.posts || this.state.posts.length < 1) && !this.state.loader ?
                        <TableNoData
                            columnWidths={ [100, 100, 100, 120, 150, 80, 200, this.state.lastColumnWidth > 150 ? this.state.lastColumnWidth : 150] }
                            columnHeaderTitles={['Type', 'Sent', 'Clicked', 'Image', "Title", "Link", "Tags", "Sent at"]}
                            minWidth={ 1000 }
                            textComponent={ <h2>You didn't run any Web Push campaigns yet. <br/>
                                Make sure to subscribe yourself and send post to yourself to test it.</h2>}
                        />
                        :
                        this.state.selectedSubTypeFinished === this.props.selectedSubType.name ?
                        <Table
                            className='campaign-performance-table'
                            resizeRowsByApproximateHeight={ true }
                            renderMode={ RenderMode.NONE }
                            numRows={ this.state.lastPage ? this.state.lastPageSize === this.state.posts.length ?
                                this.state.lastPageSize : this.state.posts.length :
                                this.state.pageSize === this.state.posts.length ? this.state.pageSize : this.state.posts.length }
                            key={ this.state.lastPage ? this.state.lastPageSize === this.state.posts.length ?
                                this.state.lastPageSize : this.state.posts.length :
                                this.state.pageSize === this.state.posts.length ? this.state.pageSize : this.state.posts.length }
                            selectionModes={ SelectionModes.NONE }
                            // defaultRowHeight={ this.state.defaultRowHeight }
                            rowHeights={ this.state.rowHeights}
                            columnWidths={ [100, 100, 100, 120, 150, 80, 200, this.state.lastColumnWidth > 150 ? this.state.lastColumnWidth : 150] }
                            onColumnWidthChanged={ async(index, width) => await this.updateTableWidth(index, width) }
                            forceRerenderOnSelectionChange={ this.state.forceTableRerender }
                        >
                            <Column
                                cellRenderer={ this.typeCellRenderer }
                                name="Type"
                            />
                            <Column
                                cellRenderer={ this.sentCellRenderer }
                                name="Sent"
                            />
                            <Column
                                cellRenderer={ this.clickedCellRenderer }
                                name="Clicked"
                            />
                            <Column name="Image" cellRenderer={ this.imageCellRenderer }/>
                            <Column name="Title" cellRenderer={ this.titleCellRenderer }/>
                            <Column name="Link" cellRenderer={ this.linkCellRenderer }/>
                            <Column name="Tags" cellRenderer={ this.tagsCellRenderer }/>
                            <Column name="Sent at" cellRenderer={ this.sentAtCellRenderer }/>
                        </Table>
                        :
                        <Table
                            className='campaign-performance-table'
                            selectionModes={ SelectionModes.NONE }
                            columnWidths={ [100, 100, 100, 120, 150, 80, 200, this.state.lastColumnWidth > 150 ?
                                this.state.lastColumnWidth : this.state.lastColumnWidth === '' ? 1000 : 150] }
                            numRows={ 10 }
                            key={10}
                            rowHeights={ [100, 100, 100, 100, 100, 100, 100, 100, 100, 100] }
                        >
                            <Column
                                cellRenderer={ this.typeCellRendererLoading }
                                name="Type"
                            />
                            <Column
                                cellRenderer={ this.sentCellRendererLoading }
                                name="Sent"
                            />
                            <Column
                                cellRenderer={ this.clickedCellRendererLoading }
                                name="Clicked"
                            />
                            <Column
                                cellRenderer={ this.imageCellRendererLoading }
                                name="Image"
                            />
                            <Column name="Title" cellRenderer={ this.titleCellRendererLoading }/>
                            <Column name="Link" cellRenderer={ this.linkCellRendererLoading }/>
                            <Column name="Tags" cellRenderer={ this.tagsCellRendererLoading }/>
                            <Column name="Sent at" cellRenderer={ this.sentAtCellRendererLoading }/>
                        </Table>
                    }

                    <div className="subscribers-shown">
                        <Pagination
                            itemsCount={parseInt(this.state.totalPosts)}
                            pageSize={ this.state.pageSize }
                            currentPage={currentPage}
                            onPageChange={this.handlePageChange}/>
                        <ItemsPerPage
                            handleItemChange={item => this.handleChangeCampaignsNumberPerPage(item.value)}
                            selectedPageSize={ this.state.pageSize}
                        />
                    </div>
                </div>
                {/*{ console.log(this.state.currentPage, this.state.totalPosts, this.state.totalPages, this.state.lastPageSize, this.state.lastPage)}*/}
            </React.Fragment>
        )
    }
}

export default WhatsAppCampaignPerformance